<template>
  <div class="step-three-content">
    <div class="extras-training-title" v-if="trainingsNotEmpty">
      Najbliższe szkolenia
    </div>
    <div class="extras-row" v-if="trainingsNotEmpty">
      <div
      v-for="t in trainings"
      v-on:click="extraClick(t.id)"
      class="extras"
      v-bind:key="t.id"
      v-bind:class="{
        new: t.new,
        popular: t.popular,
        recommended: t.recommended,
        active: extraIsActive(t.id),
        disabled: extraIsDisabled(t.id)
      }">
        <div class="extras-active-check"></div>
        <div class="extras-image-wrapper">
          <div
            class="extras-image-blurred"
            :style="{ backgroundImage: 'url(' + t.image + ')' }"
          ></div>
          <div
            class="extras-image"
            :style="{ backgroundImage: 'url(' + t.image + ')' }"
          >
            <div class="extras-info-label">
              <span class="extras-date">{{ t.date }}</span><span class="extras-hour">{{ t.hour }}</span>
            </div>
          </div>
        </div>
        <div class="extras-content">
          <div class="extras-name">
            {{ t.name }}
          </div>
          <div class="extras-footer">
            <div class="extras-help-icon has-tooltip" v-on:click.stop.prevent v-if="t.tooltip">
              <div class="tooltip">
                {{ t.tooltip }}
              </div>
            </div>
            <div v-else></div>
            <div class="extras-old-price" v-if="t.pricePromo">
              {{ toFixedTwo(t.price) }} zł
            </div>
            <div class="extras-current-price">
              <span v-if="t.pricePromo">{{ toFixedTwo(t.pricePromo) }} zł</span>
              <span v-else>{{ toFixedTwo(t.price) }} zł</span>
            </div>
            <div class="extras-price-for-vip has-tooltip" v-if="t.priceVip || t.pricePromoVip" v-on:click.stop.prevent >
              <span class="tooltip">Korzystaj z wyjątkowych zniżek na dodatki przeznaczonych dla użytkowników z planem VIP.</span>
              <span class="star--vip"></span> Cena dla VIP <span v-if="t.pricePromoVip">{{ toFixedTwo(t.pricePromoVip) }} zł</span><span v-else>{{ toFixedTwo(t.priceVip) }}  zł</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="extras-other-title" v-if="othersNotEmpty">
      Pozostałe dodatki
    </div>
    <div class="extras-row" v-if="othersNotEmpty">
      <div
      v-for="o in others"
      v-on:click="extraClick(o.id)"
      class="extras"
      v-bind:key="o.id"
      v-bind:class="{
        new: o.new,
        popular: o.popular,
        recommended: o.recommended,
        active: extraIsActive(o.id),
        disabled: extraIsDisabled(o.id)
      }">
        <div class="extras-active-check"></div>
        <div class="extras-image-wrapper">
          <div
            class="extras-image-blurred"
            :style="{ backgroundImage: 'url(' + o.image + ')' }"
          ></div>
          <div
            class="extras-image"
            :style="{ backgroundImage: 'url(' + o.image + ')' }"
          ></div>
        </div>
        <div class="extras-content">
          <div class="extras-name">
            {{ o.name }}
          </div>
          <div class="extras-footer">
            <div class="extras-help-icon has-tooltip" v-on:click.stop.prevent v-if="o.tooltip">
              <div class="tooltip">
                {{ o.tooltip }}
              </div>
            </div>
            <div v-else></div>
            <div class="extras-old-price" v-if="o.pricePromo">
              {{ toFixedTwo(o.price) }} zł
            </div>
            <div class="extras-current-price">
              <span v-if="o.pricePromo">{{ toFixedTwo(o.pricePromo) }} zł</span>
              <span v-else>{{ toFixedTwo(o.price) }} zł</span>
            </div>
            <div class="extras-price-for-vip has-tooltip" v-if="o.priceVip || o.pricePromoVip" v-on:click.stop.prevent>
              <span class="tooltip">Korzystaj z wyjątkowych zniżek na dodatki przeznaczonych dla użytkowników z planem VIP.</span>
              <span class="star--vip"></span> Cena dla VIP <span v-if="o.pricePromoVip">{{ toFixedTwo(o.pricePromoVip) }} zł</span><span v-else>{{ toFixedTwo(o.priceVip) }} zł</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="extras-training-title" v-if="!trainingsNotEmpty && !othersNotEmpty">
      Przepraszamy, obecnie nie ma dodatków na sprzedaż.
    </div>
    <div class="button-wrapper">
      <router-link v-if="selectedPeriodIndex !== null" class="back-step-button" :to="{ name: 'PaymentStepPeriod' }">Cofnij</router-link>
      <router-link v-else class="back-step-button" :to="{ name: 'PaymentStepPlan' }">Cofnij</router-link>

      <router-link class="skip-step-button" v-if="selectedPeriodIndex !== null" :to="{ name: 'PaymentStepSummary' }" v-on:click.native="deselectAllExtras">Nie chcę żadnych dodatków</router-link>
      <router-link class="next-step-button button" :class="{ disabled: selectedExtrasCount === 0 }" :to="{ name: 'PaymentStepSummary' }">Wybieram dodatek</router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import mixin from '@/mixin'

export default {
  name: 'PaymentStepExtra',
  mixins: [mixin],
  computed: {
    ...mapState([
      'user',
      'trainings',
      'others',
      'selectedExtrasIds',
      'selectedPeriodIndex'
    ]),
    ...mapGetters([
      'selectedExtrasCount'
    ]),
    trainingsNotEmpty: function () {
      if (this.trainings.length > 0) {
        return true
      } else {
        return false
      }
    },
    othersNotEmpty: function () {
      if (this.others.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapMutations([
      'selectExtra',
      'deselectExtra',
      'deselectAllExtras'
    ]),
    extraIsActive (extraId) {
      if (this.selectedExtrasIds.includes(extraId)) {
        return true
      } else {
        return false
      }
    },
    extraIsDisabled (extraId) {
      if (this.user.disabledExtras.includes(extraId)) {
        return true
      } else {
        return false
      }
    },
    extraClick (extraId) {
      if (this.extraIsActive(extraId)) {
        this.deselectExtra(extraId)
      } else {
        this.selectExtra(extraId)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.step-three-content{
  margin-top: 50px;
}
.extras-training-title{
  color: #41CDA8;
  font-size: 15px;
  font-weight: 500;
  font-family: 'Roboto-Medium';
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
}
.extras-other-title{
  margin-top: 50px;
  color: #999;
  font-size: 15px;
  font-weight: 500;
  font-family: 'Roboto-Medium';
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
}
.extras-row{
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
}
.extras{
  flex-basis: 234px;
  position: relative;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.1);
  transition: border 0.3s ease-out;
  cursor: pointer;
  background-color: white;
  margin: 0px 10px;
  margin-bottom: 25px;
}
.extras.disabled {
  opacity: 0.4;
}
.extras:hover{
    box-shadow: 0 5px 15px 0 rgba(0,0,0,0.2);
}
.extras.active:before{
  content: '';
  position: absolute;
  height: calc(100% - 8px);
  width: calc(100% - 8px);
  border: 4px solid #41CDA8;
  z-index: 1;
}
.extras-active-check{
  opacity: 0;
  content: '';
  z-index: 1;
  position: absolute;
  top: -15px;
  left: calc(100% + -12px);
  width: 16px;
  height: 15px;
  padding: 9px 5px;
  background-image: url(../../assets/img/common/icon_selected.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: opacity 0.2s linear;
}
.active .extras-active-check{
  opacity: 1;
  z-index: 2;
}
.extras:after{
  content: '';
  position: absolute;
  height: 100px;
  width: 100px;
  top: -8px;
  left: -8px;
  z-index: 2;
}
.extras.recommended:after{
  background-image: url(../../assets/img/common/recommended.png)
}
.extras.popular:after{
  background-image: url(../../assets/img/common/popular.png)
}
.extras.new:after{
  background-image: url(../../assets/img/common/new.png);
}
.extras-image-wrapper{
  position: relative;
  height: 130px;
  overflow: hidden;
}
.extras-image{
  height: 130px;
  width: 100%;
  position: absolute;
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
  filter: blur(0px);
  overflow: hidden;
}
.extras-image-blurred{
  height: 130px;
  width: 100%;
  position: absolute;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(3px);
  overflow: hidden;
}
.extras-info-label{
  position: absolute;
  width: 100%;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.48);
  text-align: center;
  padding: 6px 0;
  display: flex;
  justify-content:space-around;
}
.extras-info-label span{
  color: #fff;
  font-size: 12px;
  padding-left: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
}
.extras-date{
  background-image: url(../../assets/img/common/icon_calendar.svg);
}
.extras-hour{
  background-image: url(../../assets/img/common/icon_watch.svg);
}
.extras-content{
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 170px);
  background-color: #FFFFFF;
}
.extras-name{
  font-size: 15px;
  padding-bottom: 30px;
  margin-bottom: auto;
}
.extras-footer{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.extras-help-icon{
  width: 20px;
  height: 20px;
  background-image: url(../../assets/img/common/icon_question_mark.svg);
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  top: 2px;
  padding-right: 3px;
}
.extras-old-price {
  align-self: center;
  font-weight: 300;
  font-family: 'Roboto-Light';
  color: #999;
  text-decoration: line-through;
  padding-right: 15px;
}
.extras-current-price {
  font-size: 22px;
  font-weight: 700;
  font-family: 'Roboto-Regular';
  color: #41CDA8;
}
.extras-price-for-vip {
  padding-top: 10px;
  color: #FF9F1C;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  flex-basis: 100%;
  align-items: baseline;
  align-content: flex-end;
}
.extras-price-for-vip span:first-child{
  font-weight: 300;
}
.star--vip{
  position: relative;
  top: 3px;
  padding-right: 3px;
}
.extras-price-for-vip span:last-child{
  font-size: 16px;
  margin-left: auto;
  font-weight: bold;
  font-family: 'Roboto-Regular';
}
.extras-help-icon:hover .tooltip{
  display: block;
}
.skip-step-button {
  margin-left: auto;
}
@media screen and (max-width: 768px) {
  .step-three-content{
    margin-top: 0px;
  }
}
@media screen and (max-width: 590px) {
  .skip-step-button{
    margin-left: initial;
  }
}
</style>
